const _bags = {
	'acorn-pochette': {
		name: 'Acorn Pochette',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		recipe: {
			acorn: 6,
		},
		variations: {
			brown: 'Brown',
		},
	},
	'basket-pack': {
		name: 'Basket Pack',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		recipe: {
			'young-spring-bamboo': 6,
		},
		variations: {
			green: 'Green',
		},
	},
	'bug-cage': {
		name: 'Bug Cage',
		sellPrice: {
			currency: 'bells',
			value: 122,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 490,
			},
		],
		variations: {
			green: 'Green',
		},
	},
	'bunny-day-bag': {
		name: 'Bunny Day Bag',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		recipe: {
			'earth-egg': 1,
			'stone-egg': 1,
			'leaf-egg': 1,
			'wood-egg': 1,
			'sky-egg': 1,
			'water-egg': 1,
		},
		variations: {
			colorful: 'Colorful',
		},
	},
	'butterfly-backpack': {
		name: 'Butterfly Backpack',
		sellPrice: {
			currency: 'bells',
			value: 210,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 840,
			},
		],
		variations: {
			pink: 'Pink',
		},
	},
	'canvas-backpack': {
		name: 'Canvas Backpack',
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			white: 'White',
		},
	},
	'cherry-blossom-pochette': {
		name: 'Cherry-blossom Pochette',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		recipe: {
			'cherry-blossom-petal': 6,
		},
		variations: {
			pink: 'Pink',
		},
	},
	'cloth-shoulder-bag': {
		name: 'Cloth Shoulder Bag',
		orderable: true,
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 350,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1400,
			},
		],
		variations: {
			blue: 'Blue',
			orange: 'Orange',
			ivory: 'Ivory',
		},
	},
	'crossbody-bag': {
		name: 'Crossbody Bag',
		sellPrice: {
			currency: 'bells',
			value: 175,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 700,
			},
		],
		variations: {
			pink: 'Pink',
			green: 'Green',
			yellow: 'Yellow',
			white: 'White',
		},
	},
	'crossbody-boston-bag': {
		name: 'Crossbody Boston Bag',
		sellPrice: {
			currency: 'bells',
			value: 420,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1680,
			},
		],
		variations: {
			red: 'Red',
			blue: 'Blue',
		},
	},
	'dal-backpack': {
		name: 'Dal Backpack',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 1010,
		},
		variations: {
			blue: 'Blue',
		},
	},
	'dry-bag': {
		name: 'Dry Bag',
		orderable: true,
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			yellow: 'Yellow',
			blue: 'Blue',
		},
	},
	'evening-bag': {
		name: 'Evening Bag',
		sellPrice: {
			currency: 'bells',
			value: 312,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1250,
			},
		],
		variations: {
			pink: 'Pink',
			blue: 'Blue',
			black: 'Black',
		},
	},
	'extra-large-backpack': {
		name: 'Extra-large Backpack',
		sellPrice: {
			currency: 'bells',
			value: 525,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2100,
			},
		],
		variations: {
			red: 'Red',
			green: 'Green',
			black: 'Black',
			blue: 'Blue',
		},
	},
	'faux-fur-bag': {
		name: 'Faux-fur Bag',
		sellPrice: {
			currency: 'bells',
			value: 350,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1400,
			},
		],
		variations: {
			pink: 'Pink',
			purple: 'Purple',
		},
	},
	'fish-pochette': {
		name: 'Fish Pochette',
		orderable: false,
		sources: ['Fishing tournament prize pool (January, April, July, October)'],
		sellPrice: {
			currency: 'bells',
			value: 210,
		},
		variations: {
			blue: 'Blue',
		},
	},
	'foldover-top-backpack': {
		name: 'Foldover-top Backpack',
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			green: 'Green',
			blue: 'Blue',
			gray: 'Gray',
			pink: 'Pink',
		},
	},
	'gumdrop-shoulder-bag': {
		name: 'Gumdrop Shoulder Bag',
		sellPrice: {
			currency: 'bells',
			value: 500,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2000,
			},
		],
		variations: {
			pop: 'Pop',
			cool: 'Cool',
		},
	},
	'hand-knit-pouch': {
		name: 'Hand-knit Pouch',
		sellPrice: {
			currency: 'bells',
			value: 312,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1250,
			},
		],
		variations: {
			green: 'Green',
			purple: 'Purple',
		},
	},
	'hard-shell-backpack': {
		name: 'Hard-shell Backpack',
		sellPrice: {
			currency: 'bells',
			value: 420,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1680,
			},
		],
		variations: {
			blue: 'Blue',
			red: 'Red',
			silver: 'Silver',
		},
	},
	knapsack: {
		name: 'Knapsack',
		sellPrice: {
			currency: 'bells',
			value: 157,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 630,
			},
		],
		variations: {
			blue: 'Blue',
			black: 'Black',
		},
	},
	'knitted-grass-backpack': {
		name: 'Knitted-grass Backpack',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 400,
		},
		recipe: {
			'clump-of-weeds': 20,
		},
		variations: {
			green: 'Green',
		},
	},
	'log-pack': {
		name: 'Log Pack',
		orderable: false,
		customizable: false,
		sellPrice: {
			currency: 'bells',
			value: 960,
		},
		recipe: {
			wood: 3,
			hardwood: 5,
		},
		variations: {
			brown: 'Brown',
		},
	},
	'maple-leaf-pochette': {
		name: 'Maple-leaf Pochette',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		variations: {
			red: 'Red',
		},
	},
	'messenger-bag': {
		name: 'Messenger Bag',
		sellPrice: {
			currency: 'bells',
			value: 210,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 840,
			},
		],
		variations: {
			green: 'Green',
			orange: 'Orange',
			black: 'Black',
		},
	},
	'mini-pleather-bag': {
		name: 'Mini Pleather Bag',
		sellPrice: {
			currency: 'bells',
			value: 400,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1600,
			},
		],
		variations: {
			white: 'White',
			black: 'Black',
		},
	},
	'moms-knapsack': {
		name: "Mom's Knapsack",
		orderable: false,
		sources: ['In the mail'],
		sellPrice: {
			currency: 'bells',
			value: 175,
		},
		variations: {
			m: 'M',
			flowers: 'Flowers',
			'polka-dots': 'Polka dots',
			'colorful-quilt-design': 'Colorful quilt design',
			cherries: 'Cherries',
			'denim-with-stripes': 'Denim with stripes',
			'forest-print': 'Forest print',
			chick: 'Chick',
		},
	},
	'nook-inc-knapsack': {
		name: 'Nook Inc. Knapsack',
		orderable: true,
		sources: ['Nook Miles System'],
		sellPrice: {
			currency: 'bells',
			value: 4000,
		},
		buyPrices: [
			{
				currency: 'miles',
				value: 800,
			},
		],
		variations: {
			brown: 'Brown',
		},
	},
	'outdoor-backpack': {
		name: 'Outdoor Backpack',
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			avocado: 'Avocado',
			orange: 'Orange',
			'navy-blue': 'Navy blue',
		},
	},
	'pleather-crossbody-bag': {
		name: 'Pleather Crossbody Bag',
		orderable: true,
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 280,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1120,
			},
		],
		variations: {
			'navy-blue': 'Navy blue',
			black: 'Black',
		},
	},
	'pleather-fringe-bag': {
		name: 'Pleather Fringe Bag',
		sellPrice: {
			currency: 'bells',
			value: 600,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2400,
			},
		],
		variations: {
			camel: 'Camel',
			white: 'White',
		},
	},
	'pleather-shoulder-bag': {
		name: 'Pleather Shoulder Bag',
		sellPrice: {
			currency: 'bells',
			value: 600,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2400,
			},
		],
		variations: {
			brown: 'Brown',
			'navy-blue': 'Navy blue',
		},
	},
	'retro-sports-bag': {
		name: 'Retro Sports Bag',
		sellPrice: {
			currency: 'bells',
			value: 350,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1400,
			},
		],
		variations: {
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
		},
	},
	'sacoche-bag': {
		name: 'Sacoche Bag',
		sellPrice: {
			currency: 'bells',
			value: 245,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 980,
			},
		],
		variations: {
			blue: 'Blue',
			red: 'Red',
			black: 'Black',
		},
	},
	'shellfish-pochette': {
		name: 'Shellfish Pochette',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 10800,
		},
		variations: {
			white: 'White',
		},
	},
	'snowflake-pochette': {
		name: 'Snowflake Pochette',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 2400,
		},
		variations: {
			white: 'White',
		},
	},
	'square-backpack': {
		name: 'Square Backpack',
		sellPrice: {
			currency: 'bells',
			value: 325,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1300,
			},
		],
		variations: {
			yellow: 'Yellow',
			pink: 'Pink',
			green: 'Green',
		},
	},
	'star-pochette': {
		name: 'Star Pochette',
		orderable: false,
		sellPrice: {
			currency: 'bells',
			value: 3000,
		},
		recipe: {
			'star-fragment': 6,
		},
		variations: {
			yellow: 'Yellow',
		},
	},
	'straw-pochette': {
		name: 'Straw Pochette',
		orderable: true,
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 245,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 980,
			},
		],
		variations: {
			brown: 'Brown',
		},
	},
	'studded-backpack': {
		name: 'Studded Backpack',
		orderable: true,
		sources: ['Kicks'],
		sellPrice: {
			currency: 'bells',
			value: 390,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1560,
			},
		],
		variations: {
			black: 'Black',
			white: 'White',
		},
	},
	'tackle-bag': {
		name: 'Tackle Bag',
		orderable: false,
		sources: ['Fishing tournament prize pool (January, April, July, October)'],
		sellPrice: {
			currency: 'bells',
			value: 175,
		},
		variations: {
			blue: 'Blue',
		},
	},
	'tool-bag': {
		name: 'Tool Bag',
		sellPrice: {
			currency: 'bells',
			value: 227,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 910,
			},
		],
		variations: {
			black: 'Black',
		},
	},
	'town-backpack': {
		name: 'Town Backpack',
		sellPrice: {
			currency: 'bells',
			value: 260,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 1040,
			},
		],
		variations: {
			green: 'Green',
			orange: 'Orange',
			blue: 'Blue',
			red: 'Red',
		},
	},
	'travel-pouch': {
		name: 'Travel Pouch',
		sellPrice: {
			currency: 'bells',
			value: 210,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 840,
			},
		],
		variations: {
			pink: 'Pink',
			green: 'Green',
			'light-blue': 'Light blue',
			purple: 'Purple',
		},
	},
	'travelers-backpack': {
		name: "Traveler's Backpack",
		sources: ["Kick's"],
		sellPrice: {
			currency: 'bells',
			value: 735,
		},
		buyPrices: [
			{
				currency: 'bells',
				value: 2940,
			},
		],
		variations: {
			orange: 'Orange',
			blue: 'Blue',
			brown: 'Brown',
		},
	},
};

export { _bags };
